import Client from './client';

export default class Contexts extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/contexts`, {
      ...options,
       method: 'POST',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/contexts/${id}`, options);
  }

  deleteById(id, options = {}) {
    return this.makeRequest(`${this.host}/contexts/${id}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
